import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBridge: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconBridge"><Path d="M12 4.5C16.2802 4.5 19.75 7.96979 19.75 12.25V12.5811C21.3225 12.9244 22.5 14.3245 22.5 16C22.5 17.933 20.933 19.5 19 19.5C17.067 19.5 15.5 17.933 15.5 16C15.5 14.3245 16.6775 12.9244 18.25 12.5811V12.25C18.25 8.79822 15.4518 6 12 6C8.54822 6 5.75 8.79822 5.75 12.25V12.5811C7.32254 12.9244 8.5 14.3245 8.5 16C8.5 17.933 6.933 19.5 5 19.5C3.067 19.5 1.5 17.933 1.5 16C1.5 14.3245 2.67746 12.9244 4.25 12.5811V12.25C4.25 7.96979 7.71979 4.5 12 4.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBridge;
